module.exports = __webpack_public_path__ + "img/st-logo.d11bf1ac.svg";